import * as styles from './ShufflerLayout.module.css'

import React from 'react'

import { formatDuration } from 'utils/formatDuration'

import * as Typography from 'components/Typography'

import { SimulationState } from '../data/SimulationState'
import { PlaybackControls } from './PlaybackControls'
import TextColumn from 'src/components/typesetting/TextColumn'

interface Props {
  simulationState?: SimulationState
  title?: string
  caption?: string
  controls?: React.ReactNode
  children: React.ReactNode
  playing: boolean
  actions: {
    play: () => void
    pause: () => void
    reset: () => void
  }
}

export const ShufflerLayout: React.FC<Props> = (props) => {
  const {
    simulationState,
    title,
    controls,
    children,
    caption,
    playing,
    actions,
  } = props

  return (
    <div className={styles.container}>
      <TextColumn>
        <div className={styles.header}>
          <PlaybackControls playing={playing} {...actions} />

          {title != null && <div className={styles.title}>{title}</div>}

          {controls != null && (
            <div className={styles.controls}>{controls}</div>
          )}
        </div>
      </TextColumn>

      {children}

      <div>
        {simulationState != null && (
          <TextColumn>
            <div className={styles.stats}>
              <div>Riffles: {simulationState.riffles}</div>
              <div>Remixes: {simulationState.remixes}</div>
              <div>Time ≈ {formatDuration(simulationState.time)}</div>
            </div>
          </TextColumn>
        )}

        {caption != null && <Typography.Caption>{caption}</Typography.Caption>}
      </div>
    </div>
  )
}
